import { useHistory } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { useCampaignItemRoutes } from 'components/pages/campaign-settings/campaign-auction/useCampaignItemRoutes';
import { useCurrentCampaign } from 'customHooks/useCurrentCampaign';
import { useCurrentCampaignItem } from 'customHooks/useCurrentCampaignItem';
import { isQueryKeyIndexMeta } from 'helpers/reactQuery';
import { campaignQueryKeys } from 'queries/campaign-query-keys';
import { CampaignItem } from 'types/domain';

const useItemDetails = () => {
    const history = useHistory();
    const itemRoutes = useCampaignItemRoutes();
    const { data: campaign } = useCurrentCampaign();
    const { data: item } = useCurrentCampaignItem<CampaignItem>();
    const queryClient = useQueryClient();

    const onDeleteItem = async () => {
        queryClient.invalidateQueries({
            queryKey: campaignQueryKeys.items(campaign.id),
            type: 'all',
            predicate: isQueryKeyIndexMeta,
        });
        history.replace(itemRoutes.index());
    };

    return {
        item,
        history,
        campaign,
        itemRoutes,
        onDeleteItem,
    };
};

export { useItemDetails };
